// Address helpers — handle the structured fields and gracefully fall back to the legacy single-line `address`.

export function formatAddress(rec) {
  if (!rec) return "";
  const street = (rec.street_address || "").trim();
  const city = (rec.city || "").trim();
  const state = (rec.state || "").trim();
  const zip = (rec.zip_code || "").trim();
  if (street || city || state || zip) {
    const cityState = [city, state].filter(Boolean).join(", ");
    return [street, cityState, zip].filter(Boolean).join(", ");
  }
  return (rec.address || "").trim();
}

// City / state values for filter dropdowns — pulled from structured fields only.
export function distinctLocations(records) {
  const cities = new Set();
  const states = new Set();
  records.forEach((r) => {
    if (r.city) cities.add(r.city.trim());
    if (r.state) states.add(r.state.trim());
  });
  return {
    cities: Array.from(cities).sort().map((c) => ({ value: c, label: c })),
    states: Array.from(states).sort().map((s) => ({ value: s, label: s })),
  };
}
